<template>

    <div id="modalDeleteDeclarer" class="modal is-open">
        <div class="modal__overlay"></div>
        <div class="modal__inner">
            <div class="modal__container modal__container--md">
                <div class="modal__content card">
                    <div class="modal__title h3">Вы действительно хотите удалить заявителя {{declarer.Name}} {{declarer.FIO}} из Вашего профиля?</div>
                    <div class="modal__body">
                        <div class="phone-submit">
                            <form action="">
                                <div class="phone-submit__form">
                                    <div class="panel panel--justify">
                                        <a class="button button--th-main"                        
                                        v-on:click="deleteDeclarer();$emit('close')">Да</a>
                                        <a class="button button--th-main"
                                           v-on:click="$emit('close')">Нет</a>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <button class="modal__close button-icon button-icon--th-slider" v-on:click="$emit('close')">
                    <i class="icon icon--close"></i>
                </button>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
		props: ['declarer'],

        data: function () {
            return {
                serverResponse: '',
            }
        },
        created: function () {
            console.log(this.declarer);
        },

         methods: {
            deleteDeclarer: function () {
                var self = this;
                 var thisElem = document.getElementById('modalDeleteDeclarer');
				 var parentElem = thisElem.parentNode.parentNode.parentNode.parentNode.parentNode;
                     
				axios.delete('/Profiles/DeleteDeclarer', {
                    data: self.declarer}                  
                  )
                    .then(function (response) {
                        self.serverResponse = response.data;
                        console.log(response.status);
						self.reloadPage(parentElem);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            reloadPage: function (elem) {
               // window.location.reload();
				//document.location.href = '/'
				elem.style.display = 'none';
                //this.$emit('remove');
            }
 
        }
    }

</script>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ModalDeleteDeclarer.vue